export default __webpack_public_path__ + "static/media/GroundNut.6661627f.jpg";